import { useEffect } from 'react';
import { usePleditor } from '../../Preview/Pleditor';
const SHOW = '_showRevisionViewer';
export const useOnShowRevisionHistory = (callback) => {
    const { plugins } = usePleditor();
    useEffect(() => {
        const { revisionHistory } = plugins;
        if (!revisionHistory) {
            return undefined;
        }
        revisionHistory.on(SHOW, callback);
        return () => {
            revisionHistory.off(SHOW, callback);
        };
    }, [callback, plugins]);
};
